export const products = [
  {
    id: 1,
    name: 'Лавандова нота',
    price: 380,
    oldPrice: 600,
    rating: 4.9,
    reviews: 234,
    category: 'ароматичні',
    emoji: '💜',
    description: 'Розслабляючий аромат лаванди',
    colors: ['Фіолетовий', 'Білий'],
    inStock: true,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 2,
    name: 'Трояндова квітка',
    price: 650,
    rating: 5.0,
    reviews: 189,
    category: 'ароматичні',
    emoji: '🌹',
    description: 'Ніжний аромат червоної троянди',
    colors: ['Червоний', 'Рожевий'],
    inStock: true,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 3,
    name: 'Різдвяна казка',
    price: 320,
    rating: 4.8,
    reviews: 345,
    category: 'святкові',
    emoji: '🎄',
    description: 'Святковий аромат корицi та апельсину',
    colors: ['Зелений', 'Червоний'],
    inStock: true,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 4,
    name: 'Океанський бриз',
    price: 520,
    rating: 4.7,
    reviews: 156,
    category: 'релакс',
    emoji: '🌊',
    description: 'Свіжий морський аромат для енергії',
    colors: ['Блакитний', 'Білий'],
    inStock: true,
    isNew: true,
    isBestseller: false,
  },
  {
    id: 5,
    name: 'Ванільна мрія',
    price: 450,
    rating: 4.6,
    reviews: 278,
    category: 'ароматичні',
    emoji: '🟡',
    description: 'Теплий ванільний аромат для затишку',
    colors: ['Кремовий', 'Жовтий'],
    inStock: false,
    isNew: false,
    isBestseller: true,
  },
  {
    id: 6,
    name: 'Містична ніч',
    price: 890,
    rating: 4.9,
    reviews: 92,
    category: 'декоративні',
    emoji: '🌙',
    description: 'Загадковий аромат для особливих моментів',
    colors: ['Чорний', 'Фіолетовий'],
    inStock: true,
    isNew: true,
    isBestseller: false,
  },
];

export default products;
